import React, { useEffect, useState } from "react";
import axios from "axios";
import Menu from './MenuPage';
import { API_BASE_URL } from '../config/api';


export default function ListaExames() {
    const token = localStorage.getItem("token");
    //const idUsuario = localStorage.getItem("idUsuario");

    const [exames, setExames] = useState([]);
    const [loading, setLoading] = useState(false);

    // Filtros
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [tutores, setTutores] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [idTutor, setIdTutor] = useState("");
    const [idPaciente, setIdPaciente] = useState("");

    // Carrega exames ao abrir
    useEffect(() => {
        listarExames(20); // take = 20
        carregarTutores();
    }, []);

    // Carrega tutores
    const carregarTutores = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/tutor/getAll`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTutores(response.data);
        } catch (err) {
            console.error("Erro ao carregar tutores", err);
        }
    };

    // Carrega pacientes conforme tutor selecionado
    const carregarPacientes = async (idTutor) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/paciente/getAllTutor/${idTutor}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPacientes(response.data);
        } catch (err) {
            console.error("Erro ao carregar pacientes", err);
        }
    };

    // Função genérica para buscar exames
    const listarExames = async (take = null) => {
        setLoading(true);

        try {
            const params = {
              
                datainicio: dataInicio || null,
                datafim: dataFim || null,
                idPaciente: idPaciente || null,
                take: take // só envia se take !== null
            };

            // Remove "take" se filtros forem usados
            if (dataInicio || dataFim || idPaciente) {
                delete params.take;
            }

            const response = await axios.get(`${API_BASE_URL}/Exame/GetAll`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            console.log(response.data)
            setExames(response.data);
        } catch (err) {
            console.error("Erro ao buscar exames", err);
        }

        setLoading(false);
    };

    // Abrir PDF do laudo
    const abrirPdf = async (id) => {
      //  window.open(`${API_BASE_URL}/${id}/pdf`, "_blank");
      const response = await axios.get(`${API_BASE_URL}/exame/${id}/pdf`, {
                  responseType: "blob",
                  headers: { "Authorization": `Bearer ${token}` }
              });
      
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `laudo_${id}.pdf`);
              document.body.appendChild(link);
              link.click();
      
              window.URL.revokeObjectURL(url);
              link.remove();
    };

    return (
        <div >
                    <Menu />
                 
        
               
        <div style={{ padding: "20px" }}>
            <h2>Lista de Exames</h2>

            {/* FILTROS */}
            <div
                style={{
                    padding: "15px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    marginBottom: "20px"
                }}
            >
                <h3>Filtros</h3>

                <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                    <div>
                        <label>Data Inicial:</label><br />
                        <input
                            type="date"
                            value={dataInicio}
                            onChange={(e) => setDataInicio(e.target.value)}
                        />
                    </div>

                    <div>
                        <label>Data Final:</label><br />
                        <input
                            type="date"
                            value={dataFim}
                            onChange={(e) => setDataFim(e.target.value)}
                        />
                    </div>

                    <div>
                        <label>Tutor:</label><br />
                        <select
                            value={idTutor}
                            onChange={(e) => {
                                setIdTutor(e.target.value);
                                setIdPaciente("");
                                carregarPacientes(e.target.value);
                            }}
                        >
                            <option value="">Selecione</option>
                            {tutores.map((t) => (
                                <option key={t.id} value={t.id}>{t.nome}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label>Paciente:</label><br />
                        <select
                            value={idPaciente}
                            onChange={(e) => setIdPaciente(e.target.value)}
                        >
                            <option value="">Selecione</option>
                            {pacientes.map((p) => (
                                <option key={p.id} value={p.id}>{p.nome}</option>
                            ))}
                        </select>
                    </div>

                    <div style={{ alignSelf: "end" }}>
                        <button onClick={() => listarExames(null)}>
                            Filtrar
                        </button>
                    </div>
                </div>
            </div>

            {/* LOADING */}
            {loading && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <img src="/loading.gif" alt="carregando" width={120} />
                    <p>Carregando...</p>
                </div>
            )}

            {/* TABELA DE EXAMES */}
            {!loading && (
                <table width="100%" border="1" cellPadding="8">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Tipo de Exame</th>
                            <th>Data Laudo</th>
                            <th>Paciente</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exames.map((e) => (
                            <tr key={e.id}>
                                <td>{e.id}</td>
                                <td>{e.idTipoExameNavigation.descricao}</td>
                                <td>{new Date(e.datalaudo).toLocaleDateString("pt-BR")}</td>
                                <td>{e.idPacienteNavigation.nome}</td>
                                <td>
                                    <button onClick={() => abrirPdf(e.id)}>
                                        Abrir PDF
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    </div>
    );
}
